import { useStaticQuery, graphql } from 'gatsby';

export const useDirectIntegrations = (limit = 8) => {
  let integrations = [];

  const { allPaperformDirectIntegration, allPaperformIntegrationApp } =
    useStaticQuery(
      graphql`
        query UseDirectIntegrationsQuery {
          allPaperformIntegrationApp {
            edges {
              node {
                url
                slug
                categories
                logo
                title
              }
            }
          }
          allPaperformDirectIntegration {
            edges {
              node {
                id
                name
                label
              }
            }
          }
        }
      `,
    );

  const apps = allPaperformIntegrationApp.edges;

  integrations = allPaperformDirectIntegration.edges.map(({ node }) => {
    let name = node.name;
    if (name === 'clicksendsms') name = 'clicksend';
    const app = apps.find(
      ({ node: { slug } }) =>
        slug === name ||
        slug.toLowerCase().replace(/-/, '') ===
          name.toLowerCase().replace(/-/, ''),
    ) || { node: {} };

    return {
      ...app.node,
      ...node,
    };
  });

  return integrations.length > limit
    ? integrations.slice(0, limit)
    : integrations;
};
